export const ApplyMenuBehaviorEnum = {
  APPLY_NEXT_AVAILABLE: 0,
  SKIP_CORRESPONDING_DAY: 1,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ApplyMenuBehaviorEnum.js